module.exports = __webpack_public_path__ + "img/hospital-corridor.1fdb0109.jpg";